import http from "./http";

export function requestMemberSettings() {
  return http
    .get("/public/locale_dictionaries/member_setting", {
      params: {
        platform: "web",
      },
    })
    .then(({ data }) => data);
}
